import { createMuiTheme } from '@material-ui/core/styles';
import amber from '@material-ui/core/colors/amber';
import red from '@material-ui/core/colors/red';

export const theme = createMuiTheme({
  typography: {
    textTransform: 'none',
   
    // fontFamily: 'Helveticasans-serif',
    button: {
      fontFamily: 'Source Sans Pro", Helvetica, Arial, sans-serif',
      fontWeight: 600,
      textTransform: 'none'
    },
  },
  input: {
    borderRadius:10,  
    borderColor: '#ffc107',
  },
  palette: {
    primary: amber,
    secondary: {
      main: '#ffc107'
    }
  },
  status: {
    danger: red
  }
});
